export const blockIconsCommunicationBusiness = (
	<span className='material-symbols-outlined'>business</span>
);
